import * as React from 'react'
import { useMemo } from 'react'
import { useItemCodes } from '../../../../core/contexts/itemCodes'
import Select from './Select'

// const source = `${process.env.REACT_APP_PER1_URL}/api/item_codes`

export const ItemCodeSelect = ({
  mode = undefined,
  type,
  valueKey,
  isStatus = false,
  filter = undefined,
  ...props
}) => {
  const types = useMemo(() => [type], [type])
  const { itemCodes } = useItemCodes(types)

  const items = []

  if (isStatus) {
    items.push({
      value: '-1',
      labelKey: 'candidate.no_status',
    });
  }

  (itemCodes[type] || []).forEach(item => {
    items.push({
      value: item[valueKey || '@id'],
      label: item.label,
      ...item,
    })
  })

  const filteredItems = filter ? items.filter(filter) : items

  return (
    <Select
      {...props}
      valueKey={valueKey}
      mode={mode}
      showSearch
      empty={!isStatus}
      items={filteredItems}
      filterOption={(input, option) => {
        if(typeof option.children === "string") {
          return option.children.toLowerCase().includes(input)
        }if(option.item?.label){
          // eslint-disable-next-line no-unused-expressions
          return option.item?.label?.toLowerCase().includes(input)
        }
        return true
      }}
      filterSort={(optionA, optionB) => {
        if(typeof optionA.children === "string" && typeof optionB.children === "string") {
          optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
        }
      }}
    />
  )
}

/* export const ItemCodeSelect = ({mode = undefined, type,...props}) => {
  const lang = useCurrentLang()
  return (
    <AsyncSelect
      component={AsyncSelect}
      source={`${source}?tipo=${type}&_lang=${lang}`}
      mode={mode}
      {...props}
    />
  )
} */
